import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import AuthRedirect from "./components/pages/AuthRedirect";
import Home from "./components/pages/Home";
import Login from "./components/pages/Login/Login";
import { useSelector } from "react-redux";
import Dashboard from "./components/pages/Dashboard/Dashboard";

const AppRoutes = () => {
  const isAuthenticated = useSelector((state) => state.isAuthenticated);
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && location.pathname === "/login") {
      window.location.replace("/dashboard"); // Redirect to dashboard after login
    }
  }, [isAuthenticated, location]);

  return (
    <Routes>
      {/* MSAL Redirect Handling */}
      <Route path="/auth/aad-redirect" element={<AuthRedirect />} />
      {/* Redirect already logged-in users away from login */}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/home" element={<Home />} />
      </Route>
      {/* Default route: Redirect based on authentication */}
      <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;